import { CLEAR_SEARCHED_CONTACTS } from 'actions';

export default function clearContacts() {
  return (dispatch) => dispatch({ type: CLEAR_SEARCHED_CONTACTS });
}
